import { render } from "./Category.vue?vue&type=template&id=02848940"
import script from "./Category.vue?vue&type=script&scoped=true&lang=js"
export * from "./Category.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__